import type { OwnSettingsIssue } from '../model/settings'

/** Те же поля, что `ConnectionFormProps` пакета `platform-ui`: совместимость проверяет компилятор в `apps/web`. */
export interface OwnConnectionFormProps {
  settings: Readonly<Record<string, unknown>>
  onChange: (settings: Record<string, unknown>) => void
  disabled: boolean
  issues: readonly OwnSettingsIssue[]
  context?: {
    resources: readonly { id: string; kind: string; displayName: string; enabled: boolean }[]
    choices: Readonly<Record<string, readonly { value: string; label: string; group?: string }[]>>
  }
}

/**
 * Настройка ресурса «Собственный источник»: настраивать в реестре нечего. Номенклатура и цены — сам ресурс, вид цены по умолчанию задаётся
 * в службе ресурса, а кассовый агент и терминал — на компьютере кассира.
 */
export function OwnConnectionForm(_props: OwnConnectionFormProps) {
  return (
    <div className="krp-own-form">
      <p>
        Собственный источник ведёт свою номенклатуру и цены, а РМК и чеки работают поверх них: отдельно подключать каталог не нужно. Кассовый
        агент и терминал настраиваются на компьютере кассира и здесь не задаются.
      </p>
    </div>
  )
}
